export const SHEET_ID =
	process.env.SHEET_ID || "1DyHkIrTFfInojYGGFsUXszMjRPhqSt8uwyF-Jd4V_H0";
export const GID = process.env.GID || "1189212490";
export const bannerBackgroundColor = "#FE3F7F";
